window.addEventListener("DOMContentLoaded", () => {
  const swiper = new Swiper(".start-slide", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 10000,
    },
    pagination: {
      el: ".two-column-image-text-general__dots",
      clickable: true,
    },
  });

  const triggerElements = document.querySelectorAll(".video-iframe-trigger");

  triggerElements.forEach((item) => {
    let target = item.dataset.target;
    let targetURLPath = item.dataset.targeturlpath;
    let iframeWrapper = item
      .closest(".two-column-image-text-general")
      .querySelector(".two-column-image-text-general__iframe-wrapper");

    if (target) {
      item.addEventListener("click", (e) => {
        e.preventDefault();

        iframeWrapper.classList.add("iframe-visible");
        let iframe = iframeWrapper.querySelector("iframe");

        iframe.setAttribute(
          "src",
          `https://www.youtube-nocookie.com/embed/${target}?autoplay=1`
        );
      });
    }

    if (targetURLPath) {
      item.addEventListener("click", (e) => {
        e.preventDefault();

        iframeWrapper.classList.add("iframe-visible");
        let video = iframeWrapper.querySelector("video");

        video.setAttribute("src", `${targetURLPath}`);
        video.load();
        video.play();
      });
    }

    iframeWrapper.addEventListener("click", () => {
      iframeWrapper.classList.remove("iframe-visible");

      if (iframeWrapper.querySelector("iframe")) {
        let iframe = iframeWrapper.querySelector("iframe");
        iframe.setAttribute("src", "");
      }

      if (iframeWrapper.querySelector("video")) {
        let video = iframeWrapper.querySelector("video");
        video.setAttribute("src", "");
      }
    });
  });
});
